import * as React from "react";
import {FormLabel,
    FormControl,
    FormGroup,
    FormControlLabel,
    Checkbox,
} from '@mui/material';
import {useLocation} from "react-router-dom";
import {readQueryParams, searchParam} from "../epic/searchEpic";
import { useUpdateQueryParam } from "../hook";


interface Props {
    type: 'cyclade' | 'elib'
}

export const CycladeFilter: React.FC<Props> = ({type}: Props) => {

    const searchLocation = useLocation().search;
    const queryFilters = readQueryParams(searchParam, searchLocation);
    const capitalizeFirstLetter = (string: string) => string.charAt(0).toUpperCase() + string.slice(1);
    const handleUpdateQueryParam = useUpdateQueryParam();

    const handleChangeStatus = (name: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked)
            handleUpdateQueryParam(type,[...queryFilters[type], name])
        else {
            handleUpdateQueryParam(type,queryFilters[type].filter((x: string) => x !== name))
        }
    };


    const availableEtat = ["Non valide", "Non vérifié", "Valide"]

    return (
        <FormControl component="fieldset" sx={{ margin: '2px 0'}}>
            <FormLabel component="legend" style={{marginBottom: 3, paddingTop: 10}}>Validation {capitalizeFirstLetter(type)}</FormLabel>
            <FormGroup>
                <div>
                    {availableEtat.map(x =>
                        <FormControlLabel
                            key={x}
                            control={<Checkbox color="primary" sx={{ padding: '0 .2rem 0 .5rem', fontSize: '4px'}}
                                               onChange={handleChangeStatus(x)}
                                               checked={queryFilters[type]?.indexOf(x) > -1} size="small"/>}
                            label={x}
                        />
                    )}


                </div>
            </FormGroup>
        </FormControl>
    )
};
